export enum SnackbarTypes {
  SNACKBAR_SUCCESS = 'SNACKBAR_SUCCESS',
  SNACKBAR_FAIL = 'SNACKBAR_FAIL',
  SNACKBAR_INFO = 'SNACKBAR_INFO',
  SNACKBAR_RESET = 'SNACKBAR_RESET',
}
